/**
 * @type {string}
 * @description - The similar images icon web component.
 */
export const SIMILAR_IMAGES_ICON_WEB_COMPONENT = 'similar-images-icon-component';
